import Box from '@mui/material/Box';
import StyledSvg from './styled-svg';

type MaxBadgeSize = 'md' | 'lg';

interface IMapIconProps {
    maxBadgeSize: MaxBadgeSize;
}

const MapIcon = ({ maxBadgeSize }: IMapIconProps) => {
    const widthValue = maxBadgeSize === 'lg' ? '5rem' : '4rem';
    const heightValue = maxBadgeSize === 'lg' ? '5.625rem' : '4.5rem';
    const innerHeightValue = maxBadgeSize === 'lg' ? '4.375rem' : '3.5rem';
    const transformYValue = maxBadgeSize === 'lg' ? 'translateY(20px)' : 'translateY(16px)';
    const negativeTransformYValue = maxBadgeSize === 'lg' ? 'translateY(-20px)' : 'translateY(-16px)';

    return (
        <Box sx={{ height: { xs: '4.5rem', md: heightValue } }}>
            <Box
                sx={{
                    width: { xs: '4rem', md: widthValue },
                    height: { xs: '3.5rem', md: innerHeightValue },
                    borderRadius: { xs: 0.75, md: 1 },
                    boxShadow: 4,
                    transform: { xs: 'translateY(16px)', md: transformYValue },
                }}
            >
                <StyledSvg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    viewBox="0 0 80 90"
                    sx={{
                        width: { md: widthValue },
                        height: { md: heightValue },
                        transform: { xs: 'translateY(-16px)', md: negativeTransformYValue },
                    }}
                >
                    <rect fill="#ede7db" y="20" width="80" height="70" rx="16" ry="16" />
                    <g>
                        <path
                            fill="none"
                            d="M49.04,75.36c-.72.04-1.42.11-2.12.16.71-.06,1.4-.12,2.13-.16,1.66-.09,3.27-.12,4.83-.1-1.56-.02-3.18.01-4.84.1Z"
                        />
                        <polygon fill="none" points="4.47 40.53 4.47 40.54 12.67 35.11 12.51 35.21 4.47 40.53" />
                        <path fill="none" d="M34.61,77.39c.54-.13,1.11-.23,1.66-.35-.55.12-1.12.22-1.66.35h0Z" />
                        <path fill="none" d="M49.48,82.7c-4.59.25-8.75.88-12.51,1.73,3.76-.85,7.93-1.48,12.51-1.73Z" />
                        <polygon fill="none" points="6.59 41.54 9.76 49.21 6.59 41.54 6.59 41.54" />
                        <path fill="none" d="M35.24,79.29c4.17-.95,8.8-1.65,13.91-1.93-5.11.27-9.74.97-13.91,1.93Z" />
                        <path
                            fill="none"
                            d="M56.46,48.9l10.39,14.72s.01,0,.02,0l-10.4-14.74-26.05,1.3h0s26.05-1.29,26.05-1.29h-.01Z"
                        />
                        <path
                            fill="none"
                            d="M75.18,61.52c-1.33-5.97-3.99-21.43-5.8-32.09,1.79,10.67,4.47,26.13,5.8,32.09Z"
                        />
                        <path fill="none" d="M66.61,76.61s0,0,0,0h.01l.87-10.04s-.01,0-.02,0l-.87,10.03Z" />
                        <path
                            fill="none"
                            d="M4.79,40.16c-.09.05-.17.13-.23.21-.04.05-.06.11-.09.16l8.04-5.32-7.72,4.95Z"
                        />
                        <path
                            fill="none"
                            d="M33.11,72.94l1.5,4.45c.54-.12,1.11-.23,1.66-.35,3.28-.69,6.83-1.22,10.65-1.52.71-.06,1.4-.12,2.12-.16,1.66-.09,3.28-.12,4.84-.1,4.69.06,8.93.57,12.73,1.35l.87-10.03c-11.69,2.17-24.22,4.49-34.37,6.37Z"
                        />
                        <path
                            fill="none"
                            d="M40.56,54.19c10.74,0,19.44,2.74,19.44,6.11s-8.7,6.11-19.44,6.11c-3.09,0-5.99-.23-8.58-.63l.42,4.23h.01c10.47-1.95,23.28-4.32,34.44-6.39l-10.39-14.72h.01s-26.05,1.29-26.05,1.29l.48,4.81c2.85-.51,6.14-.81,9.66-.81Z"
                        />
                        <polygon
                            fill="none"
                            points="37.06 21.38 6.59 41.54 9.76 49.21 55.1 46.95 37.06 21.37 37.06 21.38"
                        />
                        <path
                            fill="none"
                            d="M53.09,40.62l15.94,22.61c2.18-.4,4.28-.79,6.27-1.16-.04-.17-.08-.35-.12-.55-1.33-5.97-4-21.43-5.8-32.09l-16.29,11.19Z"
                        />
                        <path
                            fill="#a6d379"
                            d="M2.66,68.22c-.93,0-1.81.16-2.65.44v5.34c0,4.32,1.72,8.24,4.51,11.12,3.83-.85,6.7-4.26,6.7-8.33,0-4.73-3.84-8.57-8.56-8.57Z"
                        />
                        <path
                            fill="#a6d379"
                            d="M7.76,49.59l-3.64-8.81.34-.23h-.01.02s0-.01,0-.02h0c.02-.05.06-.11.1-.17.06-.08.14-.15.23-.21h0s8.67-5.57,8.67-5.57l-.95.63.16-.1.78-.52,22.03-14.58h-12.59c-1.98.95-4.21,1.73-5.45,2.39-2.97,1.59-4.43,5.66-7.62,7.21-1.41.69-3,.97-4.48.88-1.48-.08-2.85-.52-3.8-1.29-.14.3-.28.6-.4.91-.32.81-.59,1.65-.77,2.52-.03.14-.05.28-.08.42-.07.35-.12.7-.16,1.06-.02.14-.04.29-.05.43-.04.49-.07.98-.07,1.47v15.6l.94-.23.43-.11,6.37-1.68Z"
                        />
                        <path
                            fill="#a6d379"
                            d="M4.79,40.16l7.72-4.95.95-.63-8.67,5.56h0c-.09.07-.17.14-.23.22-.04.06-.08.12-.1.18h0c.03-.06.05-.12.09-.17.06-.08.14-.16.23-.21Z"
                        />
                        <path
                            fill="#0090ff"
                            d="M5.34,30.49c1.47.08,3.06-.2,4.46-.88h.01c3.19-1.56,4.66-5.63,7.62-7.22,1.25-.67,3.47-1.44,5.45-2.39h-6.89c-.5,0-.99.03-1.47.07-.14.01-.29.03-.43.05-.36.04-.71.1-1.06.16-.14.03-.28.05-.42.08-1.5.32-2.93.85-4.25,1.57-.45.25-.89.51-1.32.8-.85.58-1.64,1.23-2.37,1.95-.36.36-.71.74-1.03,1.14-.4.49-.77,1.01-1.11,1.55-.04.06-.07.12-.11.18-.32.53-.63,1.07-.89,1.64,0,0,.01,0,.02.01,0,0,0,0,0-.01.95.77,2.31,1.22,3.79,1.3Z"
                        />
                        <path
                            fill="#0090ff"
                            d="M5.34,30.49c-1.48-.08-2.84-.53-3.79-1.3,0,0,0,0,0,.01.95.77,2.32,1.21,3.8,1.29Z"
                        />
                        <path
                            fill="#a6d379"
                            d="M74.16,45.32h5.84v-9.32c0-3.01-.85-5.81-2.29-8.22l-6.44.8c.85,5.03,1.89,11.1,2.89,16.74Z"
                        />
                        <path
                            fill="#0090ff"
                            d="M73.95,86.51c1.51-1.2,2.79-2.67,3.77-4.32-2.62-1.15-5.71-2.26-9.29-3.13l-.48,5.47c2.29.61,4.29,1.3,6,1.98Z"
                        />
                        <path
                            fill="#0090ff"
                            d="M49.15,77.36c-5.11.28-9.74.98-13.91,1.93l1.73,5.14c3.76-.85,7.92-1.48,12.51-1.73,6.39-.35,11.93.31,16.49,1.34l.47-5.43c-4.95-1.03-10.72-1.61-17.29-1.25Z"
                        />
                        <path
                            fill="#0090ff"
                            d="M16.01,90h5.42c3.53-1.8,8.08-3.68,13.61-5.1l-1.72-5.13c-10.09,2.59-17.26,6.65-21.54,9.64,1.34.37,2.75.58,4.22.58Z"
                        />
                        <path
                            fill="#fff"
                            d="M80.01,45.32h-5.86c-1-5.65-2.04-11.72-2.89-16.74l6.45-.8s0,0,0,0h0c-.39-.65-.81-1.27-1.29-1.86l-3.74.46,2.05-2.22c-.49-.45-1.01-.87-1.56-1.26l-3.52,3.81-6.25-5.08,1.13-1.61c-.18,0-.36-.03-.54-.03h-.66l-.7,1-1.24-1h-1.59l9.05,7.35-9.96,6.84-4.13-14.19h-2.08l4.48,15.39-5.24,3.6-13.39-18.98h-3.06s.03.01.03.01l-22.05,14.59-.79.51-8.2,5.43s0,0,0,.01l-.34.23,3.64,8.81h.01s-6.37,1.69-6.37,1.69l-.44.1-.95.26v2.06l9.26-2.46,19.16-.95.51,5.12c.63-.15,1.28-.28,1.96-.41l-.48-4.81h0s0-.01,0-.01l26.05-1.3,10.4,14.74s-.01,0-.02,0v.02c-11.15,2.06-23.98,4.44-34.45,6.38l-.42-4.24c-.7-.11-1.38-.23-2.03-.36l.5,4.98c-8.54,1.58-15.23,2.83-17.68,3.29-1.33-4.31-5.35-7.46-10.1-7.46-.92,0-1.8.13-2.65.35v2.08c.84-.28,1.72-.44,2.65-.44,4.72,0,8.56,3.85,8.56,8.57,0,0,0,0,0,0,0,0,0,0,0,0,0,4.08-2.88,7.49-6.7,8.34.55.57,1.14,1.09,1.77,1.57,4.04-1.48,6.94-5.36,6.94-9.91v-.15c2.25-.42,9.02-1.68,17.93-3.33l1.53,4.56c-11.21,2.9-18.92,7.57-23.14,10.68l-.06.05c.74.33,1.5.6,2.29.82,0,0,0,0,0,0,0,0-.02,0-.03,0,4.28-3,11.45-7.06,21.55-9.65h.01s0,.01,0,0l1.72,5.14c-5.53,1.42-10.08,3.3-13.61,5.1h4.73c2.74-1.16,5.91-2.28,9.52-3.2l1.07,3.2h2.11l-1.24-3.67c3.6-.8,7.59-1.4,11.97-1.64,6.24-.34,11.66.3,16.21,1.36l-.34,3.87c.69-.06,1.37-.17,2.04-.32l.27-3.05c1.5.41,2.87.87,4.15,1.34.71-.41,1.39-.87,2.03-1.38,0,0,0,0-.01,0,0,0,0,0,0,0-1.71-.68-3.71-1.38-6.01-1.99l.48-5.48s.01,0,.02,0h0c3.59.87,6.7,1.98,9.31,3.13.34-.57.65-1.15.92-1.76-2.82-1.24-6.17-2.45-10.06-3.38l.26-3.02,11.13.37c0-.13.02-.26.02-.4v-1.6l-10.98-.36.51-5.85c3.63-.67,7.14-1.32,10.47-1.94v-3.05c-.89.16-1.81.33-2.76.51-.55-2.43-1.59-8-2.73-14.39h5.49v-2ZM9.76,49.21l-3.17-7.67h0s0-.01,0-.01l30.47-20.16,18.04,25.58-45.34,2.26ZM65.97,84.04c-4.56-1.03-10.1-1.68-16.49-1.34-4.58.25-8.75.88-12.51,1.73l-1.73-5.14c4.17-.96,8.8-1.66,13.91-1.93,6.57-.36,12.34.21,17.29,1.25l-.47,5.43ZM66.63,76.61h-.01s0,0,0,0h0c-3.79-.78-8.04-1.29-12.73-1.35-1.56-.02-3.17.01-4.83.1-.73.04-1.42.11-2.13.16-3.82.3-7.36.83-10.65,1.52-.55.12-1.12.22-1.66.35h0s0,0,0,0h0l-1.5-4.45c10.16-1.88,22.69-4.2,34.39-6.37h0s.01,0,.02,0l-.87,10.04ZM75.18,61.52c.04.19.08.38.12.55-1.99.37-4.09.76-6.27,1.16l-15.94-22.61,16.29-11.19c1.8,10.67,4.47,26.13,5.8,32.09Z"
                        />
                        <path
                            fill="#fff"
                            d="M53.88,75.26c4.69.06,8.94.57,12.73,1.35h0c-3.79-.78-8.04-1.3-12.73-1.35Z"
                        />
                        <path fill="#fff" d="M46.92,75.52c-3.82.3-7.36.82-10.65,1.52,3.28-.69,6.83-1.22,10.65-1.52Z" />
                        <path
                            fill="#fff"
                            d="M67.48,66.57h0c-11.7,2.17-24.23,4.49-34.39,6.37l1.5,4.45h0s0,0,0,0l-1.5-4.45c10.15-1.88,22.68-4.2,34.37-6.37Z"
                        />
                        <path
                            fill="#fff"
                            d="M32.4,70.01l-.42-4.23s0,0,0,0l.42,4.24c10.47-1.94,23.3-4.32,34.46-6.38v-.02c-11.17,2.07-23.98,4.44-34.45,6.38h-.01Z"
                        />
                        <polygon fill="#fff" points="30.42 50.19 30.42 50.19 30.9 55 30.9 55 30.42 50.19" />
                        <polygon fill="#fff" points="37.06 21.37 6.59 41.53 6.59 41.54 37.06 21.38 37.06 21.37" />
                        <path
                            fill="#fff"
                            d="M2.66,68.21c-.93,0-1.81.16-2.65.44H.01c.84-.27,1.72-.43,2.65-.43,4.72,0,8.56,3.84,8.56,8.57,0,0,0,0,0,0,0-4.72-3.84-8.57-8.56-8.57Z"
                        />
                        <polygon fill="#fff" points="4.46 40.55 4.47 40.54 4.45 40.55 4.46 40.55" />
                        <polygon
                            fill="#fff"
                            points="12.67 35.11 13.46 34.6 35.51 20.01 35.48 20.01 13.45 34.59 12.67 35.11"
                        />
                        <polygon fill="#fff" points="7.77 49.6 7.76 49.59 1.39 51.27 .96 51.38 1.4 51.28 7.77 49.6" />
                        <path
                            fill="#fff"
                            d="M71.26,28.58c.85,5.02,1.89,11.09,2.89,16.74h0c-1-5.64-2.04-11.71-2.89-16.74l6.44-.8s0,0,0,0l-6.45.8Z"
                        />
                        <path
                            fill="#fff"
                            d="M67.93,84.53c2.3.61,4.3,1.31,6.01,1.99,0,0,0,0,0,0-1.71-.69-3.7-1.38-6-1.98l.48-5.47s-.01,0-.02,0l-.48,5.48Z"
                        />
                        <path
                            fill="#fff"
                            d="M49.48,82.7c6.39-.34,11.93.31,16.49,1.34-4.56-1.03-10.1-1.69-16.49-1.34Z"
                        />
                        <path
                            fill="#fff"
                            d="M49.15,77.36c6.57-.36,12.34.22,17.29,1.25-4.95-1.04-10.72-1.61-17.29-1.25Z"
                        />
                        <path
                            fill="#fff"
                            d="M33.31,79.76c-10.1,2.59-17.27,6.65-21.55,9.65,0,0,.02,0,.03,0,4.28-3,11.45-7.06,21.54-9.64h0s-.01-.01-.01-.01Z"
                        />
                        <path
                            fill="#bcb9b0"
                            d="M21.12,60.3c0,2.14,3.51,4.02,8.82,5.11l-1-10c-4.74,1.11-7.82,2.89-7.82,4.89Z"
                        />
                        <path
                            fill="#bcb9b0"
                            d="M60,60.3c0-3.37-8.7-6.11-19.44-6.11-3.52,0-6.81.3-9.66.81l1.08,10.77c2.59.4,5.5.63,8.58.63,10.74,0,19.44-2.74,19.44-6.11Z"
                        />
                        <path
                            fill="#cbcbcb"
                            d="M30.9,55s0,0,0,0c-.68.12-1.33.26-1.96.41l1,10c.65.13,1.33.25,2.03.36,0,0,0,0,0,0l-1.08-10.77Z"
                        />
                    </g>
                    <path
                        fill="#001333"
                        d="M40.48,0c-10.81,0-19.61,8.79-19.61,19.58s13.78,27.88,17.9,30.52c.91.58,1.33.89,1.71.89s.81-.31,1.71-.89c4.1-2.66,17.9-19.24,17.9-30.52S51.29,0,40.48,0Z"
                    />
                    <circle fill="#fff" cx="40.49" cy="19.65" r="8.16" />
                </StyledSvg>
            </Box>
        </Box>
    );
};

export default MapIcon;
